import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fb02fde4&lang=pug&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=fb02fde4&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb02fde4')) {
      api.createRecord('fb02fde4', component.options)
    } else {
      api.reload('fb02fde4', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fb02fde4&lang=pug&", function () {
      api.rerender('fb02fde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Accordion.vue"
export default component.exports